export default [
  {
    path: '/app/defines/product-categories',
    name: 'ProductCategories',
    component: () => import('@/views/Defines/Product_categories/Index.vue'),
    meta: {
      pageTitle: 'Ürün Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'PRODUCT_CATEGORIES_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/defines/product-categories/add',
    name: 'ProductCategoriesAdd',
    component: () => import('@/views/Defines/Product_categories/Add.vue'),
    meta: {
      pageTitle: 'Ürün Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/product-categories',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'PRODUCT_CATEGORIES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/defines/product-categories/edit/:id',
    name: 'ProductCategoriesEdit',
    component: () => import('@/views/Defines/Product_categories/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/product-categories',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'PRODUCT_CATEGORIES_EDIT',
      action: 'read',
    },
  },
]
